import ApplyRoutes from "./apply-routes"
import PreApplyRoutes from "./preapply-routes"
import ErrorRoutes from "./error-routes"
import ExternalRoutes from "./external-routes"
import FlowRoutes from "./flow-routes"
import InternalRoutes from "./internal-routes"
import { routes as ProviderRoutes } from "@/providers"
import TestRoutes from "./test-routes"
import type { RouteRecordRaw } from "vue-router"

import MainLayout from "@/components/layout/MainLayout.vue"

const routes: RouteRecordRaw[] = [
  {
    name: "main",
    path: "/",
    props: true,
    component: MainLayout,
    children: [
      ...FlowRoutes,
      ...InternalRoutes,
      ...ApplyRoutes,
      ...PreApplyRoutes,
      ...ErrorRoutes,
      ...ExternalRoutes,
      ...TestRoutes,
      ...ProviderRoutes,
    ],
  },
]

export default routes
